import LogManagement from "./log-management.page";

export default LogManagement;
